import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "href", "type", "disabled", "size", "theme", "icon", "iconPosition", "busy", "allowMultiline", "defaultMultiline", "flat", "notFocusable", "highlighted", "shifted", "mode"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import React, { useState, cloneElement, useRef, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTheme } from '@rescui/ui-contexts';
import { LoadingIcon } from '@rescui/icons';
import { useResizeObserver } from '@rescui/use-resize-observer';
import styles from './button.p.module.css.js';

var calculateShifted = function calculateShifted(shiftedProp, side) {
  return shiftedProp === 'all' || shiftedProp === side || Array.isArray(shiftedProp) && _includesInstanceProperty(shiftedProp).call(shiftedProp, side);
};

var MODE_STYLES = {
  classic: styles.modeClassic,
  rock: styles.modeRock,
  transparent: styles.modeTransparent,
  outline: styles.modeOutline,
  clear: styles.modeClear
};
var SIZE_STYLES = {
  xs: styles.sizeXs,
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};
var ICON_POSITION_STYLES = {
  left: styles.alignIconLeft,
  right: styles.alignIconRight
};

var useForwardedRef = function useForwardedRef(ref) {
  var innerRef = useRef(null);
  var current = innerRef.current;
  useEffect(function () {
    if (!ref) return;

    if (typeof ref === 'function') {
      ref(current);
    } else {
      ref.current = current;
    }
  }, [ref, current]);
  return innerRef;
};

var Button = /*#__PURE__*/React.forwardRef( // eslint-disable-next-line complexity
function (_ref, forwardedRef) {
  var _cn;

  var className = _ref.className,
      children = _ref.children,
      href = _ref.href,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      disabled = _ref.disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      themeFromProps = _ref.theme,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      _ref$busy = _ref.busy,
      busy = _ref$busy === void 0 ? false : _ref$busy,
      _ref$allowMultiline = _ref.allowMultiline,
      allowMultiline = _ref$allowMultiline === void 0 ? false : _ref$allowMultiline,
      _ref$defaultMultiline = _ref.defaultMultiline,
      defaultMultiline = _ref$defaultMultiline === void 0 ? false : _ref$defaultMultiline,
      flat = _flatInstanceProperty(_ref),
      notFocusable = _ref.notFocusable,
      highlighted = _ref.highlighted,
      shifted = _ref.shifted,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'classic' : _ref$mode,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(defaultMultiline),
      _useState2 = _slicedToArray(_useState, 2),
      multiline = _useState2[0],
      setMultiline = _useState2[1];

  var ref = useForwardedRef(forwardedRef);
  useResizeObserver(ref, function (entry) {
    var target = entry.target;
    var height = entry.contentRect.height;
    var targetStyles = getComputedStyle(target);
    var singleLineBlockSize = parseInt(targetStyles.lineHeight, 10);
    setMultiline(height > singleLineBlockSize);
  });
  var theme = useTheme(themeFromProps);
  var shiftedLeft = calculateShifted(shifted, 'left');
  var shiftedRight = calculateShifted(shifted, 'right');
  var shiftedTop = calculateShifted(shifted, 'top');
  var shiftedBottom = calculateShifted(shifted, 'bottom'); // check for ignored jsx values and empty string, more info https://reactjs.org/docs/jsx-in-depth.html#booleans-null-and-undefined-are-ignored

  var isWithoutText = children === null || typeof children === 'undefined' || children === false || children === true || children === '';
  var iconSlot;

  if ( /*#__PURE__*/React.isValidElement(icon) && busy) {
    iconSlot = /*#__PURE__*/React.createElement(LoadingIcon, {
      className: styles.icon
    });
  } else if ( /*#__PURE__*/React.isValidElement(icon)) {
    iconSlot = /*#__PURE__*/cloneElement(icon, {
      className: cn(icon.props.className, styles.icon)
    });
  }

  var showBusyOverlay = ! /*#__PURE__*/React.isValidElement(icon) && busy;
  var buttonSharedProps = {
    href: href,
    disabled: disabled,
    className: cn(styles.main, MODE_STYLES[mode], SIZE_STYLES[size], ICON_POSITION_STYLES[iconPosition], styles[theme], (_cn = {}, _defineProperty(_cn, styles.disabled, disabled), _defineProperty(_cn, styles.flatLeft, flat === 'left'), _defineProperty(_cn, styles.flatRight, flat === 'right'), _defineProperty(_cn, styles.highlighted, highlighted), _defineProperty(_cn, styles.withIcon, !!icon), _defineProperty(_cn, styles.withoutText, isWithoutText), _defineProperty(_cn, styles.shiftedLeft, shiftedLeft), _defineProperty(_cn, styles.shiftedRight, shiftedRight), _defineProperty(_cn, styles.shiftedTop, shiftedTop), _defineProperty(_cn, styles.shiftedBottom, shiftedBottom), _defineProperty(_cn, styles.multiline, multiline), _defineProperty(_cn, styles.allowMultiline, allowMultiline), _defineProperty(_cn, styles.busy, busy), _defineProperty(_cn, styles.busyOverlay, showBusyOverlay), _cn), className)
  }; // Google Translate replaces TextNodes on page which is leading to a React error on manipulating buttonChildren e.g. when switching to the busy state.
  // To prevent this we wrap text node in a span element which itself will not be replaced by Google Translate.
  // More info here: https://github.com/facebook/react/issues/11538

  var buttonContent = !isWithoutText && typeof children === 'string' ? /*#__PURE__*/React.createElement("span", null, children) : children;
  var buttonChildren = /*#__PURE__*/React.createElement(React.Fragment, null, iconSlot, showBusyOverlay && /*#__PURE__*/React.createElement(LoadingIcon, {
    className: styles.busyIcon,
    size: size,
    "data-test": "busy-icon"
  }), buttonContent);

  if (notFocusable) {
    if (href) {
      console.error('Button with `href` can\'t be completely not focusable. If you want to remove Button with `href` from focus flow, use `tabIndex="-1"` instead of `notFocusable`');
    }
    /** use <div> tag for preventing button controls elements behavior for example 'space' button press support. */


    return /*#__PURE__*/React.createElement("div", _objectSpread(_objectSpread({
      "data-test": 'button'
    }, restProps), {}, {
      ref: ref
    }, buttonSharedProps), buttonChildren);
  } else if (href) {
    return /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({
      "data-test": 'button'
    }, restProps), {}, {
      ref: ref,
      type: type
    }, buttonSharedProps), buttonChildren);
  } else {
    return /*#__PURE__*/React.createElement("button", _objectSpread(_objectSpread({
      "data-test": 'button'
    }, restProps), {}, {
      ref: ref,

      /* eslint-disable-next-line react/button-has-type */
      type: type
    }, buttonSharedProps), buttonChildren);
  }
});
Button.displayName = 'Button';

function validateAdditional(propType, callback) {
  return function (props, propName) {
    if (typeof props[propName] !== 'undefined') {
      var cbRes = callback(props, propName);

      if (cbRes) {
        return cbRes;
      }

      PropTypes.checkPropTypes(_defineProperty({}, propName, propType), props, 'prop', 'Button');
    }

    return null;
  };
}

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  href: validateAdditional(PropTypes.string, function (props) {
    if (typeof props.notFocusable !== 'undefined') {
      return new Error("'href' prop cannot be used with 'notFocusable' prop");
    }

    return null;
  }),
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  size: PropTypes.oneOf(['l', 'm', 's', 'xs']),
  mode: validateAdditional(PropTypes.oneOf(['classic', 'rock', 'transparent', 'outline', 'clear']), function (props) {
    if (typeof props.shifted !== 'undefined' && props.mode !== 'clear') {
      return new Error("'shifted' prop cannot be used when 'mode' prop is not 'clear'.");
    }

    return null;
  }),
  theme: PropTypes.oneOf(['light', 'dark']),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
  notFocusable: validateAdditional(PropTypes.bool, function (props) {
    if (typeof props.href !== 'undefined' || typeof props.target !== 'undefined') {
      return new Error("'notFocusable' prop cannot be used with 'href' and 'target' props");
    }

    return null;
  }),
  busy: PropTypes.bool,
  flat: PropTypes.oneOf(['left', 'right']),
  highlighted: PropTypes.bool,
  allowMultiline: PropTypes.bool,
  defaultMultiline: PropTypes.bool,
  shifted: PropTypes.oneOfType([PropTypes.oneOf(['all', 'left', 'right', 'top', 'bottom']), PropTypes.arrayOf(PropTypes.oneOf(['left', 'right', 'top', 'bottom']))])
};
export { Button, Button as default };
